export enum ELocalStorage {
    USER = 'USER',
}
